import React, {
    Fragment,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { AppContext } from "../context";
import loading from "../img/loading.gif";
import hand from "../components/Stencils/hold.svg";
import * as tf from "@tensorflow/tfjs";
import {
    PartDetector,
    setBackendExternally,
} from "../partdetection_new/PartDetector";
import { Guidance } from "../guidance_new/GuidanceMain";
import {
    addImageToList,
    setLog,
    userLogs,
    patLogs,
    setSubCompleted,
    getSubCompleted,
    setSubMandatoryCompleted,
    getSubMandatoryCompleted,
    getKotakRecaptureCase,
    setKotakRecapMenuSection,
    setKotakRecapSubSection,
    getKotakRecapSubSection,
    getConstraint,
    getAspectRatioClientList,
    getModel,
    setVideoFlag,
    getVideoFlag,
    getWebpImageFormat,
    getImgQualityFactor
} from "../context/utils";
import cameraImg from "../img/camera.png";
import Button from "./Button";
import Rotate from "./Rotate";
import leftArrow from "../img/left.png";
import rightArrow from "../img/right.png";
import white_tick from "../img/white_tick.png";
import { goodFrame } from "../guidance_new/BikeStencil";
import Right from "../components/Stencils/bike/Right";
import Front from "../components/Stencils/bike/Front";
import Rear from "../components/Stencils/bike/Rear";
import Left from "../components/Stencils/bike/Left";
import Fuel from "../components/Stencils/bike/Fuel";
import zizo_arrow from "../img/zizo_arrow.gif";
import SafeImage from "./SafeImage";
import { startVideoPlayback } from "../utils_new/videoPlayback";
import { incompleteBlockColor } from "../utils_new/theme";

let logBugs = true;
let currentSubBlock = "";
let currentTag = "";
let imageCaptured = false;
let image = {};
let overlaidImage = null;
let alignment = false;
let mandatoryMissing = [];
let subMissing = [];
let cameraStarted = false;
let track = null;
let reservedData = null;
let detectMlCheck = true;
let timeout1, timeout2;
let videoEl;

const BikeStencil = () => {
    const {
        stepCovered,
        setStepCovered,
        clientId,
        showAlert,
        condition,
        setCondition,
        setScreen,
        currentBlock,
        showOptions,
        setShowOptions,
        config,
        isLandscape,
        setLandscape,
        mandatory,
        setMandatory,
        subMandatory,
        setSubMandatory,
        setCurrentPage,
        inspectionId,
        subCondition,
        setSubCondition,
        count1,
        setCount1,
        scrollX,
        setscrollX,
        scrolEnd,
        setscrolEnd,
        isIOS
    } = useContext(AppContext);

    const guidance = new Guidance(
        config["video-page"]["guidanceMessages"],
        clientId,
        config
    );

    const land = () => window.innerWidth > window.innerHeight * 1.2;
    const [instructions, setInstructions] = useState(null);
    const [svgColor, setSVGColor] = useState("#fff");
    const [guidanceText, setGuidanceText] = useState("You're standing too close to the bike. Kindly move back a bit");
    const [currentBlockItem, setCurrentBlockItem] = useState(
        currentBlock["values"]
    );

    const [isStreamRotated, setIsStreamRotated] = useState(false);
    const resizeDebounceRef = useRef(null);

    // True when iOS hands back a portrait-oriented stream while the viewport is
    // landscape. Derived from the element instead of state so the imperative
    // paths below (which run from long-lived closures) always see live values.
    const isVideoRotated = (vw) =>
        !!vw &&
        vw.videoWidth < vw.videoHeight &&
        window.innerWidth > window.innerHeight;

    useEffect(() => {
        const checkOrientation = () => {
            const isL = land();
            setLandscape(isL);
            if (!isL) {
                if (isIOS && window.stream) {
                    window.stream.getTracks().forEach((t) => t.stop());
                    window.stream = null;
                    track = null;
                }
                setVideoFlag(false);
                cameraStarted = false;
                setIsStreamRotated(false);
                clearTimeout(timeout1);
                clearTimeout(timeout2);
            } else if (!cameraStarted) {
                setTimeout(() => startCamera(), isIOS ? 300 : 100);
            } else {
                setIsStreamRotated(isVideoRotated(videoRef.current));
                stencilResize();
            }
        };

        const handleResize = () => {
            if (isIOS) {
                // collapse the burst of resize events fired mid-rotation into a
                // single check once the orientation has settled
                if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
                resizeDebounceRef.current = setTimeout(checkOrientation, 200);
            } else {
                checkOrientation();
            }
        };

        // Menu/Instructions and friends assign window.onresize during render and
        // never clear it on unmount. That stale handler calls setLandscape()
        // undebounced, which would flip orientation mid-rotation and defeat the
        // debounce below. Park it while this view owns the screen.
        const previousOnResize = window.onresize;
        window.onresize = null;

        window.addEventListener("resize", handleResize);
        // iOS only: resize alone can be missed or mistimed mid-rotation there.
        // Elsewhere resize already covers rotation, so registering this too
        // would just double-fire checkOrientation and change behaviour that
        // works today.
        if (isIOS) window.addEventListener("orientationchange", handleResize);
        return () => {
            window.onresize = previousOnResize;
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleResize);
            if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
        };
    }, []);

    const getTranslateText = (text) => {
        if (Object.keys(config["language"]).includes(text)) {
            return config["language"][text];
        } else {
            // const data = translateText(text, config["language"]["langCode"]);
            return text;
        }
    };

    const [reduce, setReduce] = useState(false);
    if (logBugs) {
        logBugs = false;
        patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
        userLogs({
            position: 8,
            last_page: `${currentBlock.tag} Module`,
            inspectionId,
        });
    }

    let isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    let webCamPromise = null;
    let model = null;
    const cardRef = useRef();
    const singleScreen = useRef();
    const videoRef = useRef();
    const canvasRef = useRef();
    const startBtn = useRef();
    const imgRef = useRef();
    const modalRef = useRef();
    const divImgRef = useRef();
    let scrl = useRef();
    const feedBackPopUp = useRef();
    const redLineVINcontainer = useRef();
    const stencilBoxRef = useRef();
    const guidanceArrow = useRef();
    const leftArrowGuidance = useRef();
    const rightArrowGuidance = useRef();
    const stopHand = useRef();
    const partDetector = new PartDetector();

    const stencilResize = () => {
        requestAnimationFrame(() => {
            if (!videoEl || !videoEl.videoWidth || !videoEl.videoHeight) return;

            const containerWidth = window.innerWidth;
            const containerHeight = window.innerHeight;

            const videoAspect = isVideoRotated(videoEl)
                ? videoEl.videoHeight / videoEl.videoWidth
                : videoEl.videoWidth / videoEl.videoHeight;
            const containerAspect = containerWidth / containerHeight;

            let displayWidth, displayHeight;

            if (videoAspect > containerAspect) {
                // Video is wider — full width, black bars top/bottom
                displayWidth = containerWidth;
                displayHeight = containerWidth / videoAspect;
            } else {
                // Video is taller — full height, black bars sides
                displayHeight = containerHeight;
                displayWidth = containerHeight * videoAspect;
            }

            // Apply box size and position
            if (stencilBoxRef?.current) {
                const box = stencilBoxRef.current;
                box.style.width = `${displayWidth}px`;
                box.style.height = `${displayHeight}px`;
                box.style.left = `${(containerWidth - displayWidth) / 2}px`;
                box.style.top = `${(containerHeight - displayHeight) / 2}px`;
                box.style.position = "absolute";
                box.style.display = "flex";
                box.style.pointerEvents = "none";
            }

            // Show buttons/overlays
        });
    };

    const startCamera = () => {
        try {
            setSVGColor("#fff");
            setGuidanceText("");
            webCamPromise = navigator.mediaDevices
                .getUserMedia(getConstraint(config, clientId))
                .then((stream) => {
                    if (!videoRef.current) {
                        // unmounted while awaiting (Rotate screen took over)
                        stream.getTracks().forEach((t) => t.stop());
                        cameraStarted = false;
                        return;
                    }
                    window.stream = stream;
                    track = stream.getTracks()[0];

                    videoEl = videoRef.current;
                    videoEl.srcObject = stream;
                    startVideoPlayback(videoEl, config);

                    videoEl.onloadedmetadata = () => {
                        if (reservedData) {
                            divImgRef.current.src = reservedData;
                            imgRef.current.style.display = "block";
                        }
                        cameraStarted = true;
                        stencilResize();
                        if (startBtn.current) startBtn.current.style.display = "none";
                        if (redLineVINcontainer.current) redLineVINcontainer.current.style.display = "none";
                        if (stopHand.current) stopHand.current.style.display = "none";
                        setTimeout(() => {
                            setVideoFlag(true);
                            startRecording();
                        }, 500);
                    };
                })
                .catch((err) => {
                    cameraStarted = false;
                    setLog(`camera failed to start: ${err && err.name}`);
                });
        } catch (err) {
            // console.log(err);
        }
    };

    const sendLogData = async (data) => {
        userLogs(data);
    };

    const startRecording = () => {
        cardRef.current.style.display = "flex";
        Promise.all([getModel(), webCamPromise])
            .then((values) => {
                sendLogData({
                    position: 6,
                    model_initialized: "yes",
                    inspectionId,
                });
                model = values[0];
                detectFrame(videoRef.current, values[0]);
                setCurrentPage("Model initialize");
                timeout1 = setTimeout(() => {
                    if (cardRef.current) cardRef.current.style.display = "none";
                }, 10000);
                timeout2 = setTimeout(() => {
                    setVideoFlag(false);
                    if (cardRef.current) cardRef.current.style.display = "none";
                    setSVGColor("green");
                    setGuidanceText(getTranslateText("Please hold on. You are standing at the right distance. Please take a photo."));
                    if (startBtn.current) startBtn.current.style.display = "block";
                    if (redLineVINcontainer.current) {
                        redLineVINcontainer.current.style.bottom = "22%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                        if (stopHand.current) stopHand.current.style.display = "flex";
                    }
                }, 20000);
            })
            .catch((error) => {
                // console.log(error);
                sendLogData({
                    position: 6,
                    model_initialized: `no - ${error.message}`,
                    inspectionId,
                });
                setCurrentPage("Model not initialize");
            });
    };

    const captureImg = async () => {
        // patLogs("capture image button clicked", inspectionId);
        setVideoFlag(false);
        const cnv = canvasRef.current;
        const vw = videoRef.current;
        const rotated = isVideoRotated(vw);
        if (rotated) {
            cnv.width = vw.videoHeight;
            cnv.height = vw.videoWidth;
            const ctx = cnv.getContext("2d");
            ctx.translate(cnv.width / 2, cnv.height / 2);
            ctx.rotate((90 * Math.PI) / 180);
            ctx.drawImage(vw, -vw.videoWidth / 2, -vw.videoHeight / 2);
        } else {
            cnv.width = vw.videoWidth;
            cnv.height = vw.videoHeight;
            cnv.getContext("2d").drawImage(vw, 0, 0);
        }
        const imgData = getWebpImageFormat() && !isIOS
            ? cnv.toDataURL("image/webp", getImgQualityFactor())
            : cnv.toDataURL("image/jpeg");

        let overlaidImgData = null;
        try {
            if (
                Object.keys(config).includes("stencil-overlay") &&
                config["stencil-overlay"] &&
                stencilBoxRef.current &&
                stencilBoxRef.current.style.display !== "none"
            ) {
                const tempCanvas = document.createElement("canvas");
                tempCanvas.width = rotated ? vw.videoHeight : vw.videoWidth;
                tempCanvas.height = rotated ? vw.videoWidth : vw.videoHeight;
                const tempCtx = tempCanvas.getContext("2d");
                if (rotated) {
                    tempCtx.save();
                    tempCtx.translate(tempCanvas.width / 2, tempCanvas.height / 2);
                    tempCtx.rotate((90 * Math.PI) / 180);
                    tempCtx.drawImage(vw, -vw.videoWidth / 2, -vw.videoHeight / 2);
                    // drop the rotation so the stencil overlay below is drawn upright
                    tempCtx.restore();
                } else {
                    tempCtx.drawImage(vw, 0, 0);
                }

                const imgElement = stencilBoxRef.current.querySelector("img");
                const svgElement = stencilBoxRef.current.querySelector("svg");
                let drawSuccess = false;

                if (imgElement && imgElement.src && !imgElement.src.includes("shadowBox")) {
                    const tempImg = new Image();
                    tempImg.crossOrigin = "anonymous";
                    tempImg.src = imgElement.src;
                    await new Promise((resolve) => {
                        tempImg.onload = resolve;
                        tempImg.onerror = resolve;
                    });
                    if (tempImg.complete && tempImg.naturalWidth > 0) {
                        let scaleFactor = (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ? 0.9 : 1.0;
                        let sW = tempImg.naturalWidth;
                        let sH = tempImg.naturalHeight;
                        let canvasAspect = tempCanvas.width / tempCanvas.height;
                        let imgAspect = sW / sH;

                        let dWidth, dHeight;
                        if (imgAspect > canvasAspect) {
                            dWidth = tempCanvas.width * scaleFactor;
                            dHeight = (tempCanvas.width / imgAspect) * scaleFactor;
                        } else {
                            dHeight = tempCanvas.height * scaleFactor;
                            dWidth = (tempCanvas.height * imgAspect) * scaleFactor;
                        }
                        let dx = (tempCanvas.width - dWidth) / 2;
                        let dy = (tempCanvas.height - dHeight) / 2;
                        tempCtx.drawImage(tempImg, dx, dy, dWidth, dHeight);
                        drawSuccess = true;
                    }
                } else if (svgElement) {
                    const clonedSvg = svgElement.cloneNode(true);
                    clonedSvg.setAttribute("width", vw.videoWidth);
                    clonedSvg.setAttribute("height", vw.videoHeight);
                    const xml = new XMLSerializer().serializeToString(clonedSvg);
                    const svg64 = btoa(unescape(encodeURIComponent(xml)));
                    const tempImg = new Image();
                    tempImg.src = "data:image/svg+xml;base64," + svg64;
                    await new Promise((resolve) => {
                        tempImg.onload = resolve;
                        tempImg.onerror = resolve;
                    });
                    let scaleFactor = (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ? 0.9 : 1.0;
                    let dWidth = vw.videoWidth * scaleFactor;
                    let dHeight = vw.videoHeight * scaleFactor;
                    let dx = (vw.videoWidth - dWidth) / 2;
                    let dy = (vw.videoHeight - dHeight) / 2;
                    tempCtx.drawImage(tempImg, dx, dy, dWidth, dHeight);
                    drawSuccess = true;
                }

                if (drawSuccess) {
                    overlaidImgData = getWebpImageFormat() && !isIOS
                        ? tempCanvas.toDataURL("image/webp", getImgQualityFactor())
                        : tempCanvas.toDataURL("image/jpeg");
                }
            }
        } catch (e) {
            // console.error("Error creating overlaid image:", e);
        }

        divImgRef.current.src = imgData;
        reservedData = imgData;
        let region = Object.keys(config["video-page"]).includes("clientRegion")
            ? config["video-page"]["clientRegion"]
            : "eu-central-1";
        image = {
            name: `${currentTag}.jpg`,
            imgData: imgData,
            tag: `${currentBlock.tag}: ${currentTag}`,
            web_region: null,
            angle: null,
            region: region,
            env: 1,
            videoData: null,
            dialStatus: null,
            currentTag,
            currentBlockName: currentBlock["id"],
            currentSubBlock,
            overlayStencil: overlaidImgData ? true : false
        };
        if (overlaidImgData) {
            let ogName = image.name;
            let newName = ogName.replace(".jpg", "-stencil.jpg");
            overlaidImage = {
                ...image,
                name: newName,
                imgData: overlaidImgData,
                tag: image.tag + "-stencil",
            };
        } else {
            overlaidImage = null;
        }
        if (redLineVINcontainer.current) redLineVINcontainer.current.style.display = "none";
        imgRef.current.style.display = "block";
    };

    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
        setscrollX(scrollX + shift);
        if (
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const scrollCheck = () => {
        setscrollX(scrl.current.scrollLeft);
        if (
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const imageRetake = () => {
        // patLogs("retake button clicked to capture image again", inspectionId);
        reservedData = null;
        imgRef.current.style.display = "none";
        startCamera();
    };

    const goBack = () => {
        if (stencilBoxRef?.current) {
            stencilBoxRef.current.style.display = "none";
        }
        setVideoFlag(false)
        cameraStarted = false;
        setSubCompleted(false);
        setSubMandatoryCompleted(false);
        currentSubBlock = "";
        currentTag = "";
        alignment = false;
        setScreen("menu");
    };

    const removeModal = () => {
        if (modalRef && modalRef.current) modalRef.current.style.display = "none";
    };

    const captureImgFrame = (byPassBlack) => {
        if (getVideoFlag()) {
            try {
                const cnv = canvasRef.current;
                const vw = videoRef.current;
                const rotated = isVideoRotated(vw);
                cnv.width = rotated ? vw.videoHeight : vw.videoWidth;
                cnv.height = rotated ? vw.videoWidth : vw.videoHeight;

                const ctx = cnv.getContext("2d");
                if (rotated) {
                    ctx.save();
                    ctx.translate(cnv.width / 2, cnv.height / 2);
                    ctx.rotate((90 * Math.PI) / 180);
                    ctx.drawImage(vw, -vw.videoWidth / 2, -vw.videoHeight / 2);
                    ctx.restore();
                } else {
                    ctx.drawImage(vw, 0, 0);
                }
                const imageData = ctx.getImageData(0, 0, cnv.width, cnv.height);
                const { data, width, height } = imageData;

                let blackPixelCount = 0;
                for (let i = 0; i < data.length; i += 4) {
                    const [r, g, b] = [data[i], data[i + 1], data[i + 2]];
                    const brightness = (r + g + b) / 3;
                    if (brightness < 5) {
                        blackPixelCount++;
                    }
                }

                const totalPixels = width * height;
                const blackPercentage = (blackPixelCount / totalPixels) * 100;

                return byPassBlack || blackPercentage < 100
                    ? getWebpImageFormat() && !isIOS
                        ? cnv.toDataURL("image/webp", getImgQualityFactor())
                        : cnv.toDataURL("image/jpeg")
                    : false;
            }
            catch (err) {
                // console.log(err);
                return false;
            }
        }
        else return false;
    };

    const stencilGetCordinated = () => {
        const rect = stencilBoxRef.current.getBoundingClientRect();
        const scaleX = 128 / window.innerWidth;
        const scaleY = 128 / window.innerHeight;

        const topLeft = [
            (rect.left + window.scrollX) * scaleX,
            (rect.top + window.scrollY) * scaleY,
        ];

        const bottomRight = [
            (rect.right + window.scrollX) * scaleX,
            (rect.bottom + window.scrollY) * scaleY,
        ];
        return [topLeft, bottomRight];
    }


    const detectFrame = async (video, model) => {
        const newImgURL = getVideoFlag() && captureImgFrame(false);
        if (!newImgURL) {
            if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
            return;
        }

        tf.engine().startScope();
        try {
            if (cardRef.current) cardRef.current.style.display = "none";
            if (detectMlCheck) {
                detectMlCheck = false;
                patLogs("part_detection_is_working", inspectionId);
            }

            const processedFrame = partDetector.processInput(video);

            if (!processedFrame || processedFrame.size === 0) {
                // console.warn("⚠️ Skipping empty frame.");
                tf.engine().endScope();
                if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
                return;
            }

            const predictions = await model.executeAsync(processedFrame);
            const detections = await partDetector.getBikeDetectionObjects(predictions);
            let stencilBoundingBox = getVideoFlag() && stencilGetCordinated();
            let result = stencilBoundingBox[0] && stencilBoundingBox[1] && goodFrame(stencilBoundingBox[0], stencilBoundingBox[1], detections !== false ? detections["highBox"] : [], currentTag.split(" ")[0]);
            if (result === 0) {
                if (getVideoFlag()) setGuidanceText(getTranslateText("You're standing too close to the bike. Kindly move back a bit."));
                if (redLineVINcontainer.current && getVideoFlag()) {
                    redLineVINcontainer.current.style.bottom = "27%";
                    redLineVINcontainer.current.style.display = "flex";
                    if (guidanceArrow.current) guidanceArrow.current.style.display = "flex";
                    if (leftArrowGuidance.current && rightArrowGuidance.current) {
                        leftArrowGuidance.current.style.transform = "rotate(140deg)";
                        rightArrowGuidance.current.style.transform = "rotate(45deg)";
                    }
                }
                // setTimeout(() => {
                //     if(redLineVINcontainer.current)redLineVINcontainer.current.style.display = "none";
                //     setGuidanceText("");
                // }, 4000);
            }
            else if (result === 1 && getVideoFlag()) {
                setVideoFlag(false);
                if (startBtn.current) startBtn.current.style.display = "block";
                setSVGColor("green");
                setGuidanceText(getTranslateText("Please hold on. You are standing at the right distance. Please take a photo."));
                if (redLineVINcontainer.current) {
                    redLineVINcontainer.current.style.bottom = "22%";
                    redLineVINcontainer.current.style.display = "flex";
                    if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                    if (stopHand.current) stopHand.current.style.display = "flex";
                }
            }
            else if (result === 2) {
                if (getVideoFlag()) setGuidanceText(getTranslateText("You're standing too far from the bike. Kindly move closer."));
                if (redLineVINcontainer.current && getVideoFlag()) {
                    redLineVINcontainer.current.style.bottom = "27%";
                    redLineVINcontainer.current.style.display = "flex";
                    if (guidanceArrow.current) guidanceArrow.current.style.display = "flex";
                    if (leftArrowGuidance.current && rightArrowGuidance.current) {
                        leftArrowGuidance.current.style.transform = "rotate(-35deg)";
                        rightArrowGuidance.current.style.transform = "rotate(-145deg)";
                    }
                }
                // setTimeout(() => {
                //     if(redLineVINcontainer.current)redLineVINcontainer.current.style.display = "none";
                //     setGuidanceText("");
                // }, 4000);
            }
            else if (result === 3) {
                if (getVideoFlag()) setGuidanceText(getTranslateText("Please try to fit the bike using the outline"));
                if (redLineVINcontainer.current && getVideoFlag()) {
                    redLineVINcontainer.current.style.bottom = "7%";
                    redLineVINcontainer.current.style.display = "flex";
                    if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                }
                // setTimeout(() => {
                //     if(redLineVINcontainer.current)redLineVINcontainer.current.style.display = "none";
                //     setGuidanceText("");
                // }, 4000);
            }
            else if (getVideoFlag()) {
                if (getVideoFlag()) setGuidanceText("");
                if (redLineVINcontainer.current) redLineVINcontainer.current.style.display = "none";
            }
            if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
        } catch (err) {
            const backendErrorPatterns = [
                /gl.*lost/i, /webgl.*context/i, /compile.*shader/i, /link.*shader/i,
                /vertex.*shader/i, /fragment.*shader/i, /webgpu/i, /device.*lost/i,
                /wasm.*memory.*error/i, /cpu.*execution.*failed/i, /tensor.*backend.*error/i,
            ];

            // console.error("❌ Model execution failed:", err.message);
            // console.log("Backend:", tf.engine().backendName);

            if (backendErrorPatterns.some((regex) => regex.test(err.message))) {
                const fallbackBackend = tf.engine().backendName === "webgl" ? "webgpu" : "cpu";
                const switched = await setBackendExternally(fallbackBackend);
                if (switched && getVideoFlag()) {
                    requestAnimationFrame(() => detectFrame(video, model));
                }
            } else {
                if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
            }
        } finally {
            tf.engine().endScope();
        }
    };

    const modal = () => {
        if (
            getSubCompleted()
        ) {
            imageAnalysis();
            return;
        }
        if (!getSubMandatoryCompleted() || !getSubCompleted()) {
            patLogs(
                `clicked to submit button, Warning given to user some option is not completed`,
                inspectionId
            );
            if (modalRef && modalRef.current) modalRef.current.style.display = "flex";
            return;
        }
    };

    const imageNext = () => {
        // patLogs(
        //   `tick button clicked image sent for uploading... and return to ${currentBlock.id}`,
        //   inspectionId
        // );
        if (stencilBoxRef?.current) {
            stencilBoxRef.current.style.display = "none";
        }
        setVideoFlag(false)
        logBugs = true;
        reservedData = null;
        if (imageCaptured) return;
        cameraStarted = false;
        imgRef.current.style.display = "none";
        imageCaptured = true;
        window.stream = null;
        track.stop();
        let temp2 = subCondition;
        temp2[currentBlock.id][currentSubBlock] = "completed";
        setSubCondition(temp2);
        currentBlock.values.map((item) => {
            if (item.name === currentSubBlock && item.mandatory) {
                let temp3 = subMandatory;
                temp3[currentBlock.id][currentSubBlock] = "completed";
                setSubMandatory(temp3);
            }
        });
        addImageToList(image);
        if (overlaidImage) {
            addImageToList(overlaidImage);
        }
        setKotakRecapSubSection(currentBlock["tag"], currentTag);
        setLog(`${currentTag} was captured`);
        //send image here----
        checkAll();
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            sortBlock();
        }
        setCount1(count1 + 1);
        setShowOptions(true);
    };

    const sortBlock = () => {
        let tempCurrentBlock = currentBlockItem;
        const subMissingSet = new Set(subMissing);
        const subMandatoryMissingSet = new Set(mandatoryMissing);

        tempCurrentBlock.sort((a, b) => {
            const aMandatoryIncomplete = subMandatoryMissingSet.has(a.name);
            const bMandatoryIncomplete = subMandatoryMissingSet.has(b.name);

            const aIncomplete = subMissingSet.has(a.name);
            const bIncomplete = subMissingSet.has(b.name);

            // Sort by mandatory and incomplete status
            if (aMandatoryIncomplete && !bMandatoryIncomplete) return -1;
            if (!aMandatoryIncomplete && bMandatoryIncomplete) return 1;

            if (aMandatoryIncomplete && bMandatoryIncomplete) return 0;

            if (aIncomplete && !bIncomplete) return -1;
            if (!aIncomplete && bIncomplete) return 1;

            return 0;
        });
        setCurrentBlockItem(tempCurrentBlock);
    };


    const checkAll = () => {
        let tempSubCheck = true;
        let tempMandCheck = true;
        mandatoryMissing = [];
        subMissing = [];
        currentBlock.values.map(async (item) => {
            if (subCondition[currentBlock.id][item.name] === "pending") {
                tempSubCheck = false;
                subMissing.push(item.name);
            }
            if (item.mandatory) {
                if (subMandatory[currentBlock.id][item.name] === "pending") {
                    tempMandCheck = false;
                }
            }
        });

        if (tempSubCheck) {
            setSubCompleted(true);
        }
        if (tempMandCheck) {
            setSubMandatoryCompleted(true);
        }
    };

    const back = () => {
        // patLogs(
        //   `back button is clicked and return to ${currentBlock.id}`,
        //   inspectionId
        // );
        currentSubBlock = "";
        clearTimeout(timeout1);
        clearTimeout(timeout2);
        currentTag = "";
        setVideoFlag(false)
        imageCaptured = true;
        cameraStarted = false;
        window.stream = null;
        track.stop();
        setShowOptions(true);
    };

    const imageAnalysis = () => {
        finsh();
        alignment = false;
    };

    const finsh = async () => {
        if (!getSubMandatoryCompleted) return;
        patLogs(`${currentBlock.id} is completed`, inspectionId);
        cameraStarted = false;
        setVideoFlag(false)
        let temp = condition;
        if (currentBlock.mandatory) {
            let temp1 = mandatory;
            temp1[currentBlock.id] = "completed";
            setMandatory(temp1);
        }
        image = {};
        currentSubBlock = "";
        currentTag = "";
        imageCaptured = false;
        temp[currentBlock["id"]] = "completed";
        setLog(`${currentBlock["tag"]} was finished`);
        setSubCompleted(false);
        setSubMandatoryCompleted(false);
        setCondition(temp);
        setKotakRecapMenuSection(currentBlock["tag"]);
        setScreen("menu");
    };

    useEffect(() => {
        if (stencilBoxRef.current) {
            stencilBoxRef.current.style.display = "none";
        }
        setLandscape(land());
        checkAll();
        setCount1(count1 + 1);
        if (currentBlock["values"].length <= 3) {
            alignment = true;
        }
        imageCaptured = true;
        currentBlock["values"].map((e) => {
            if (e["name"].length > 14) {
                setReduce(true);
            }
        });
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            sortBlock();
        }
    }, []);

    return (
        <Fragment>
            {!isLandscape ? (
                <Rotate />
            ) : showOptions ? (
                <div className="process" style={{ position: "relative" }}>
                    <h2>{currentBlock["id"]}</h2>
                    <div className="process-main" style={{ display: "flex" }}>
                        <div
                            className="left-btn"
                            disabled={scrollX === 0}
                            onClick={() => slide(-200)}
                            style={alignment ? { display: "none" } : {}}
                        >
                            <img
                                src={leftArrow}
                                style={scrollX === 0 ? { opacity: "0.3" } : {}}
                            />
                        </div>
                        <div
                            className="process-steps"
                            ref={scrl}
                            onScroll={scrollCheck}
                            style={
                                alignment
                                    ? {
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100vw",
                                    }
                                    : {
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        width: "80vw",
                                        overflowX: "scroll",
                                        scrollBehavior: "smooth",
                                        alignItems: "center",
                                    }
                            }
                        >
                            {currentBlockItem.map((item, index) => {
                                if (
                                    subCondition[currentBlock.id][item.name] === "completed"
                                ) {
                                    return (
                                        <div key={index}>
                                            <div
                                                className="menu-options"
                                                style={reduce ? { fontSize: "10px" } : null}
                                            >
                                                {item["mandatory"] ? (
                                                    <h4
                                                        style={{
                                                            color:
                                                                getKotakRecaptureCase() &&
                                                                    getKotakRecapSubSection(
                                                                        currentBlock["tag"],
                                                                        item["tag"]
                                                                    )
                                                                    ? "rgb(0, 180, 160)"
                                                                    : config["colors"]["complete-block"],
                                                        }}
                                                        key={index}
                                                    >
                                                        {item["name"]}&#42;
                                                    </h4>
                                                ) : (
                                                    <h4
                                                        style={{
                                                            color:
                                                                getKotakRecaptureCase() &&
                                                                    getKotakRecapSubSection(
                                                                        currentBlock["tag"],
                                                                        item["tag"]
                                                                    )
                                                                    ? "rgb(0, 180, 160)"
                                                                    : config["colors"]["complete-block"],
                                                        }}
                                                        key={index}
                                                    >
                                                        {item["name"]}
                                                    </h4>
                                                )}
                                                <div
                                                    className="process-vin"
                                                    style={{
                                                        border:
                                                            getKotakRecaptureCase() &&
                                                                getKotakRecapSubSection(
                                                                    currentBlock["tag"],
                                                                    item["tag"]
                                                                )
                                                                ? "2px solid rgb(0, 180, 160)"
                                                                : `2px solid ${config["colors"]["complete-block"]}`,
                                                        opacity:
                                                            feedBackPopUp.current &&
                                                                feedBackPopUp.current.style.display === "flex"
                                                                ? ".5"
                                                                : "",
                                                    }}
                                                    onClick={() => {
                                                        if (
                                                            Object.keys(config).includes(
                                                                "recaptureAfterSubmit"
                                                            ) &&
                                                            config["recaptureAfterSubmit"] &&
                                                            getKotakRecaptureCase() &&
                                                            !getKotakRecapSubSection(
                                                                currentBlock["tag"],
                                                                item["tag"]
                                                            )
                                                        ) {
                                                            //patLogs(`${item["tag"]} is clicked`, inspectionId);
                                                            currentSubBlock = item["name"];
                                                            currentTag = item["tag"];
                                                            setShowOptions(false);
                                                            imageCaptured = false;
                                                            startCamera();
                                                            Object.keys(item).includes("cameraInstruction") &&
                                                                setInstructions(item["cameraInstruction"]);
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className="greenCircleTick"
                                                        style={
                                                            feedBackPopUp.current &&
                                                                feedBackPopUp.current.style.display === "flex"
                                                                ? { opacity: ".5" }
                                                                : {
                                                                    backgroundColor:
                                                                        getKotakRecaptureCase() &&
                                                                            getKotakRecapSubSection(
                                                                                currentBlock["tag"],
                                                                                item["tag"]
                                                                            )
                                                                            ? "rgb(0, 180, 160)"
                                                                            : "",
                                                                }
                                                        }
                                                    >
                                                        <img src={white_tick} alt="1232"></img>
                                                    </div>
                                                    <SafeImage src={item["image"]} alt="123" />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }
                                return (
                                    <div key={index}>
                                        <div
                                            className="menu-options"
                                            style={reduce ? { fontSize: "10px" } : null}
                                        >
                                            {item["mandatory"] ? (
                                                <h4 key={index}>{item["name"]}&#42;</h4>
                                            ) : (
                                                <h4 key={index}>{item["name"]}</h4>
                                            )}
                                            <div
                                                className="process-vin"
                                                style={{
                                                    border: `1px solid ${incompleteBlockColor(config)}`,
                                                }}
                                                onClick={() => {
                                                    //patLogs(`${item["tag"]} is clicked`, inspectionId);
                                                    currentSubBlock = item["name"];
                                                    currentTag = item["tag"];
                                                    setShowOptions(false);
                                                    imageCaptured = false;
                                                    startCamera();
                                                    Object.keys(item).includes("cameraInstruction") &&
                                                        setInstructions(item["cameraInstruction"]);
                                                }}
                                            >
                                                <SafeImage src={item["image"]} alt="123" />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            className="right-btn"
                            disabled={scrolEnd}
                            style={alignment ? { display: "none" } : {}}
                            onClick={() => slide(+200)}
                        >
                            <img
                                src={rightArrow}
                                style={scrolEnd ? { opacity: "0.3" } : {}}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex" }} className="InternetWarning">
                        <p>{showAlert && showAlert}</p>
                    </div>
                    <div
                        className="modal-btn-container-multipleImage"
                        style={{ display: "flex", backgroundColor: "#F8F7FC" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                width: "100%",
                            }}
                        >
                            <Button
                                secoundaryBtn="true"
                                text={config["multiple-image-page"]["back-btn-text"]}
                                onclick={goBack}
                                marginDefault="0px 0px 0px 0px"
                            />
                            <Button
                                text={config["multiple-image-page"]["next-btn-text"]}
                                disabled={
                                    !getSubMandatoryCompleted()
                                }
                                onclick={() => {
                                    modal();
                                }}
                                marginDefault="0px 25px 0px 25px"
                            />
                        </div>
                    </div>
                    <div
                        ref={modalRef}
                        className="menu-modal-container"
                        style={{ display: "none" }}
                    >
                        {!getSubMandatoryCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["mandatory-modal-text"]}</h4>
                                <h4>{mandatoryMissing.join(", ")}</h4>
                            </div>
                        ) : getSubMandatoryCompleted() && !getSubCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["optional-modal-text"]}</h4>
                                <h4>{subMissing.join(", ")}</h4>
                                <div className="modal-btn-container">
                                    <Button
                                        text={config["multiple-image-page"]["modal-btn-next"]}
                                        onclick={() => {
                                            setStepCovered([...stepCovered]);
                                            patLogs(
                                                `Warning given to user some module is not completed still user clicked final submit button`,
                                                inspectionId
                                            );
                                            imageAnalysis();
                                        }}
                                    />
                                </div>
                            </div>
                        ) : getSubCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["back-modal-text"]}</h4>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div id="vin-screen" ref={singleScreen}>
                    <canvas
                        ref={canvasRef}
                        id="ios-canvas"
                        style={
                            getAspectRatioClientList(clientId, config)
                                ? {
                                    width: "100vw",
                                    height: "100vh",
                                    objectFit: "contain",
                                    backgroundColor: "black",
                                }
                                : {}
                        }
                    ></canvas>
                    <div
                        style={{ width: "100dvw", height: "100dvh", position: "absolute" }}
                    >
                        <video
                            ref={videoRef}
                            id="videoWindow"
                            style={
                                isStreamRotated
                                    ? {
                                        width: "100vh",
                                        height: "100vw",
                                        objectFit: getAspectRatioClientList(clientId, config) ? "contain" : "cover",
                                        backgroundColor: "black",
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%) rotate(90deg)",
                                    }
                                    : getAspectRatioClientList(clientId, config)
                                        ? {
                                            // 100% against the viewport: 100vw/100vh go stale
                                            // across a rotation in WKWebView
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            backgroundColor: "black",
                                            position: "fixed",
                                            top: 0,
                                            left: 0,
                                        }
                                        : { position: "fixed", top: 0, left: 0, width: "100%", height: "100%" }
                            }
                            autoPlay
                            playsInline
                        ></video>
                        <div
                            className="stencilBox"
                            ref={stencilBoxRef}
                            style={{
                                position: "absolute"
                            }}
                        >
                            <div
                                alt=""
                                style={
                                    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                                        !window.MSStream
                                        ? {
                                            width: "90%",
                                            height: "90%",
                                            objectFit: "contain",
                                        }
                                        : { width: "100%", height: "100%", objectFit: "contain" }
                                }
                            >
                                {
                                    currentTag === "Front view" ? <Front color={svgColor} /> :
                                        currentTag === "Right view" ? <Right color={svgColor} /> :
                                            currentTag === "Rear view" ? <Rear color={svgColor} /> :
                                                currentTag === "Left view" ? <Left color={svgColor} /> : <Fuel color={svgColor} />
                                }
                            </div>
                        </div>
                    </div>
                    <div
                        className="redLineVINcontainerView"
                        style={{
                            position: "absolute",
                            bottom: "5%",  //18
                            height: "7%",
                            justifyContent: "flex-start",
                            width: "100%"
                        }}
                        ref={redLineVINcontainer}
                    >
                        <div id="hand" ref={stopHand}>
                            <img src={hand} alt="123" style={{ width: "6dvw" }} />
                        </div>
                        <div id="arrow" ref={guidanceArrow}>
                            <img id="arrowLeft" ref={leftArrowGuidance} src={zizo_arrow} alt="123" />
                            <img id="arrowRight" ref={rightArrowGuidance} src={zizo_arrow} alt="123" />
                        </div>
                        <div id="modalNameCont" style={{ height: "100%" }}>
                            <p id="modalNameText" style={{ fontSize: "20px" }}>{guidanceText}</p>
                        </div>
                    </div>
                    <div
                        ref={startBtn}
                        style={{
                            backgroundImage: `url(${cameraImg})`,
                            backgroundSize: "37px 37px",
                            backgroundRepeat: "no-repeat",
                            objectFit: "cover",
                            backgroundPosition: "center",
                        }}
                        onClick={captureImg}
                        id="btn-vin-start"
                    ></div>
                    <div className="back-btn">
                        <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
                    </div>
                    <div ref={cardRef} id="display-card-zizo">
                        <div id="zizo-loader-text" style={{ textAlign: "center" }}>
                            <h3>{config["video-page"]["loadingText"]}</h3>
                        </div>
                        <div
                            id="zizo-loader"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <SafeImage src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/custom_bike_icon/damage_icon_bike.svg" alt="123" style={{ zIndex: 5, position: "fixed", width: "8%" }} fallback={null} />
                            <img style={{ width: "50%" }} src={loading}></img>
                        </div>
                    </div>
                    {instructions && (
                        <div className="camerInst">
                            <p>{instructions}</p>
                        </div>
                    )}
                    <div
                        id="vin-image"
                        style={
                            getAspectRatioClientList(clientId, config)
                                ? { backgroundColor: "black", objectFit: "contain" }
                                : {}
                        }
                        ref={imgRef}
                    >
                        <img
                            ref={divImgRef}
                            style={
                                getAspectRatioClientList(clientId, config)
                                    ? { objectFit: "contain" }
                                    : { width: "100vw", height: "100vh" }
                            }
                        />
                        <i
                            className="fas fa-times fa-2x vin-btn-retake"
                            onClick={imageRetake}
                        ></i>
                        <i
                            className="fas fa-check fa-2x vin-btn-next"
                            onClick={imageNext}
                        ></i>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default BikeStencil;
